/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class DropZoneWorkflowBlock extends NoOutputWorkflowBlock {
        private logType: string = "DropZoneWorkflowBlock";
        
        private width: number;
        private height: number;
        private xPadding: number;
        private yPadding: number;
        private attributes: any;

        private optionalTextElement: Snap.Element;
        private textElement: Snap.Element;
        private required: boolean;
        private optionalAttributes: any;
        private optionalTextAttributes: any;

        constructor(id: string, required: boolean) {
            super(id, Wars.Domain.Model.Codes.Enums.BlockType.DropZone, "Drag Shape Here");
            this.width = 120;
            this.height = 70;
            this.xPadding = 15;
            this.yPadding = 40;

            this.attributes = { id: this.id, class: "drop-zone-workflow-block", "data-class": "workflowBlock", "data-id": "svgDropZone" };
            this.optionalAttributes = { id: this.id, class: "optional-drop-zone-workflow-block", "data-class": "workflowBlock", "data-id": "svgDropZone"};
            this.optionalTextAttributes = { class: "optional-drop-zone-text"};
            this.required = required;
        }

        getBottomPadding(): number {
            return this.yPadding;
        }

        getTopPadding(): number {
            return this.yPadding;
        }

        getLeftPadding(): number {
            return this.xPadding;
        }

        getRightPadding(): number {
            return this.xPadding;
        }

        private getMyCenterPoint(gridCoordinate: models.Coordinate): Coordinate {
            var xOffset = (gridCoordinate.x * this.blockWidth);
            var yOffset = (gridCoordinate.y * this.blockHeight);
            return new Coordinate((this.blockWidth / 2) + xOffset, this.blockHeight / 2 + yOffset);
        }

        draw(paper: Snap.Paper, coordinate: models.Coordinate): Snap.Element {
            var xOffset = (coordinate.x * this.blockWidth) + this.xPadding;
            var yOffset = (coordinate.y * this.blockHeight) + this.yPadding;

            var entireBlock = this.drawEntireBlock(paper, coordinate);
            this.svgElement = paper.rect(xOffset, yOffset, this.width, this.height, 5, 5);
            if (this.required) this.svgElement.attr(this.attributes);
            else this.svgElement.attr(this.optionalAttributes);
            

            var centerPoint = this.getMyCenterPoint(coordinate);

            var textAndRectangleGroup: any;

            if (this.required) {
                this.textElement = paper.text(centerPoint.x, centerPoint.y + 5, this.label);
                this.textElement.attr({ class: "alternate-text" });
                textAndRectangleGroup = paper.group(entireBlock, this.svgElement, this.textElement);
            } else {
                this.optionalTextElement = paper.text(centerPoint.x, centerPoint.y + 15, '(Optional)');
                this.textElement = paper.text(centerPoint.x, centerPoint.y -5, this.label);
                this.optionalTextElement.attr(this.optionalTextAttributes);
                this.textElement.attr(this.optionalTextAttributes);
                textAndRectangleGroup = paper.group(entireBlock, this.svgElement, this.optionalTextElement, this.textElement);
            }

            var dropZoneGroup = paper.group(entireBlock, textAndRectangleGroup);
            return dropZoneGroup;
        }

        drawForToolbar(paper: Snap.Paper): Snap.Element {
            throw 'Not Supported';
        }

        highlightValidOption(): void {
            //services.WarsLogger.logDebug("Highlight Valid", this.logType);
            this.svgElement.attr({ class: "hover-valid-option" });
            this.textElement.attr({ class: 'text' });
        }

        highlightInvalidOption(): void {
            this.svgElement.attr({ class: "hover-invalid-option"});
            this.textElement.attr({ class: "alternate-text" });
            //services.WarsLogger.logDebug("Highlight Invalid", this.logType);
        }

        unHighlight() : void {
            this.svgElement.attr(this.attributes);
            this.textElement.attr({ class: "alternate-text" });
        }

        getDeleteCoordinate(coordinate: models.Coordinate): Coordinate {
            throw "Never draw delete on drop zones";
        }

        getSettingsCoordinate(coordinate: models.Coordinate): Coordinate {
            throw "Never draw delete on drop zones";
        }

        updateDrawingBasedOnLabelLengths(): void { }
    }
}